import { render, staticRenderFns } from "./CourseOutline.vue?vue&type=template&id=f70a047c&"
import script from "./CourseOutline.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CourseOutline.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports